/**
 * Interim wordmark. DESIGN.md reserves the primary colour for CTAs and the
 * wordmark, so this is one of the few places blue appears on white.
 */
export function Wordmark({
  tone = 'light',
  compact = false,
  className = '',
}: {
  tone?: 'light' | 'dark'
  /** Mark only — used by the collapsed navigation rail. */
  compact?: boolean
  className?: string
}) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true">
        <rect width="28" height="28" rx="14" fill="#0052ff" />
        <path
          d="M8 18V11l6 4 6-4v7"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {!compact && (
        <span className={`t-title-md tracking-tight ${tone === 'dark' ? 'text-on-dark' : 'text-ink'}`}>
          OMC
        </span>
      )}
    </span>
  )
}
